export const SETTINGS_KEYS = {
	ENCRYPT_MEMBER_BACKUPS: "sigma_encrypt_member_backups",
} as const;

/**
 * Get member backup encryption setting from localStorage
 * Note: Prefer using useLocalStorage hook in components
 */
export function getEncryptMemberBackupsSetting(): boolean {
	if (typeof window === "undefined") {
		return true; // Default to encrypted on server
	}
	try {
		const saved = localStorage.getItem(SETTINGS_KEYS.ENCRYPT_MEMBER_BACKUPS);
		return saved === null ? true : JSON.parse(saved); // Default to true (encrypted)
	} catch {
		return true;
	}
}
